import { useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import axios from 'axios'
import { useAuth } from '../lib/auth'
import { apiErrorMessage } from '../lib/api'

export function MockStripePage() {
  const { id } = useParams<{ id: string }>()
  const [params] = useSearchParams()
  const tierCode = params.get('tier') ?? 'pro'
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState<string | null>(null)
  const auth = useAuth()
  const nav = useNavigate()

  const pay = async () => {
    if (!id || !auth.user) return
    setBusy(true)
    setErr(null)
    try {
      const apiBase = (import.meta.env.VITE_API_URL ?? '').replace(/\/$/, '')
      await axios.post(`${apiBase}/api/v1/webhooks/stripe`,
        {
          id: `mock_evt_${id}`, type: 'checkout.session.completed',
          data: { object: { id, payment_status: 'paid',
            metadata: { userId: auth.user.id, tierCode, isReset: 'false' } } },
        },
        { headers: { 'stripe-signature': 'mock_sig', 'Content-Type': 'application/json' } },
      )
      auth.refresh()
      nav(`/checkout-success?session_id=${id}`, { replace: true })
    } catch (e: unknown) {
      setErr(apiErrorMessage(e))
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="auth-shell">
      <header className="auth-shell__topbar">
        <span className="auth-shell__logo">
          <img src="/wordmark-light.svg" alt="Rival Prop Firm" className="auth-shell__logo--light" />
          <img src="/wordmark-dark.svg"  alt="Rival Prop Firm" className="auth-shell__logo--dark" />
        </span>
        <span className="admin-mode-pill" style={{ marginLeft: 'auto' }}>
          <span className="admin-mode-pill__dot" aria-hidden />
          Mock checkout
        </span>
      </header>

      <main className="auth-shell__main">
        <div className="auth-card">
          <div className="auth-card__header">
            <p className="auth-card__eyebrow">Stripe · Mock mode</p>
            <h1 className="auth-card__title">Confirm payment</h1>
            <p className="auth-card__subtitle">
              This is the development checkout. Click <strong>Pay</strong> to fire the simulated webhook.
            </p>
          </div>

          <div className="auth-card__body">
            <div style={{ background: 'var(--bg-subtle)', border: '1px solid var(--border-subtle)',
              borderRadius: 'var(--radius-md)', padding: 'var(--space-3)',
              fontSize: 'var(--text-sm)', color: 'var(--text-secondary)', marginBottom: 'var(--space-3)' }}>
              <div>Session ID:{' '}
                <code style={{ fontFamily: 'var(--font-mono)', fontSize: 'var(--text-xs)', color: 'var(--text-primary)' }}>{id}</code>
              </div>
              <div>Tier:{' '}
                <code style={{ fontFamily: 'var(--font-mono)', fontSize: 'var(--text-xs)', color: 'var(--text-primary)' }}>{tierCode}</code>
              </div>
            </div>

            {err && (
              <div className="auth-card__error" role="alert" style={{ display: 'flex' }}>{err}</div>
            )}

            <button type="button" onClick={pay}
              className="btn btn--primary auth-card__submit" disabled={busy || !auth.user}>
              {busy ? 'Processing…' : 'Pay (mock)'}
            </button>
          </div>
        </div>
      </main>
    </div>
  )
}
